<template lang="pug">
b-modal#completedModal.modal.fade.bg-primary.pt-0(
  centered,
  hide-footer="",
  title="",
  tabindex="-1",
  aria-labelledby="completedModal",
  aria-hidden="true",
  ref="completedModal",
  size="sm"
)
  h5.text-white.text-center {{ text }}
</template>

<script>
export default {
  name: "DialogCompleted",
  props: {
    text: String,
  },
};
</script>

<style lang="scss" scoped>
::v-deep #completedModal .modal-header {
  border: 0;
  padding-bottom: 0 !important;
  padding-top: 0.5rem !important;
}

::v-deep #completedModal .modal-body {
  padding-top: 0;
}

::v-deep #completedModal .modal-content {
  background-color: #0062cc;
}

::v-deep #completedModal .close {
  color: $color_white;
}

::v-deep #completedModal .close:not(:disabled):not(.disabled):hover {
  color: $color_white;
  opacity: 0.75;
}

@media only screen and (max-width: 767px) {
  ::v-deep h5 {
    font-weight: 300 !important;
  }
}
</style>
